import ReactGA from 'react-ga';

var TRACKER;

const BLACKLISTED_ACTIONS = [
  "LOAD_WEB3_START",
  "LOAD_WEB3_SUCCESS",
  "LOAD_WEB3_ACCOUNTS_START",
  "LOAD_WEB3_ACCOUNTS_SUCCESS",
  "UPDATE_BLOCK_NUMBER_START",
  "UPDATE_BLOCK_NUMBER_SUCCESS",
  "LOAD_NETWORKS_START",
  "LOAD_NETWORKS_SUCCESS",

  "POLL_AUCTIONS_GET_LIVE_START",
  "POLL_AUCTIONS_GET_LIVE_SUCCESS",
  "POLL_MY_AUCTIONS_GET_START",
  "POLL_MY_AUCTIONS_GET_SUCCESS",
  "POLL_AUCTIONS_GET_ALL_START",
  "POLL_AUCTIONS_GET_ALL_SUCCESS",
  "POLL_UNCLAIMED_BIDS_GET_ALL_START",
  "POLL_UNCLAIMED_BIDS_GET_ALL_SUCCESS",
  "POLL_MY_TEAMS_GET_START",
  "POLL_MY_TEAMS_GET_SUCCESS",
];

// Mock analytic tracker for development:
class DevelopmentTracker {
  ga(action, event, payload) {
    console.log(`DevelopmentTracker: ${action}, ${event}, ${payload}`);
  }
  event({ category, action }) {
    console.log(`DevelopmentTracker: [${category}]: ${action}`);
  }
}

// Use Google Analytics for Production:
// Use DevelopmentTracker for Development:
if (process.env.NODE_ENV === 'production') {
  TRACKER = ReactGA;
} else {
  TRACKER = new DevelopmentTracker();
}

// Redux middleware:
const analytics = store => next => action => {

  if (action.type === '@@router/LOCATION_CHANGE') {

    TRACKER.ga('send', 'pageview', action.payload.pathname);

  } else if (BLACKLISTED_ACTIONS.indexOf(action.type) === -1) {

    TRACKER.event({
      category: 'Redux',
      action: action.type,
    });

  }

  return next(action);
};

export default analytics;



// WEBPACK FOOTER //
// ./src/util/analytics.js